import Swiper from 'swiper';
const swiper = new Swiper('#documents .document_titles_mobile', {
	slidesPerView: 'auto',
	autoHeight: true,
	spaceBetween: 16,
})
import { clickOn } from '../events/click';

clickOn('#documents .document_titles_mobile .swiper-slide p', function(e) {
	document.querySelectorAll('#documents .document_titles_mobile .swiper-slide p').forEach((el) => {
		el.classList.remove('active');
	})
	e.target.classList.toggle('active');
	window.scrollTo({
		top: document.querySelector(`#documents .body .items .item[data-index="${e.target.dataset.index}"]`).offsetTop,
		behavior: 'smooth'
	});
})